import { LEAD_STATUS_LABELS } from "./labels";

const DASHBOARD_LEAD_STATUS_ROWS = [
  { key: "NEW", sourceKeys: ["NEW"] },
  { key: "QUALIFYING", sourceKeys: ["QUALIFYING"] },
  {
    key: "CONTACTED",
    sourceKeys: ["CONTACTED", "DEMO_SCHEDULED", "OFFER_REQUESTED"],
  },
];

export function buildDashboardLeadStatusRows(statusCounts = {}, { convertedCount = 0 } = {}) {
  const rows = DASHBOARD_LEAD_STATUS_ROWS.map(({ key, sourceKeys }) => ({
    key,
    label: LEAD_STATUS_LABELS[key]?.de || key,
    tone: LEAD_STATUS_LABELS[key]?.tone || "muted",
    value: sourceKeys.reduce((sum, sourceKey) => sum + (statusCounts?.[sourceKey] || 0), 0),
  }));
  return [
    ...rows,
    {
      key: "CONVERTED",
      label: "In Deal umgewandelt",
      tone: "success",
      value: convertedCount || 0,
    },
  ];
}
